import React from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import {
  Box,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  IconButton as MuiIconButton,
  Modal,
  Button,
} from "@mui/material";
import ReactJson from "react-json-view";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import { ReactComponent as CancelIcon } from "../../../../vendor/button/cancel.svg";

import { scannerNameMap } from "../../../../utils/constants";
import { Paper, Box as ModalBox } from "../../common/styled";

const IconButton = styled(MuiIconButton)`
  padding: 4px;
`;
const headCells = [
  { id: "name", alignment: "left", label: "Name" },
  { id: "valid", alignment: "center", label: "Valid" },
  { id: "score", alignment: "center", label: "Risk Score" },
  { id: "config", alignment: "center", label: "Configuration" },
];

const EnhancedTableHead = () => {
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            sx={{ padding: "8px" }}
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "normal"}
          >
            <Typography variant="tableHeader"><b>{headCell.label}</b></Typography>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
function SkeletonContent(props) {
  const { rowsPerPage } = props;
  var rowArray = [];
  for (let i = 0; i < rowsPerPage; i++) {
    rowArray.push(i);
  }
  var cellArray = [1, 2, 3];

  return (
    <TableBody>
      {rowArray.map((r) => (
        <TableRow key={"s_" + r}>
          {cellArray.map((c) => (
            <TableCell sx={{ padding: "16px 8px" }} key={"s_" + r + "_" + c}>
              <Skeleton height="22px" width="100%" py="5px" variant="rectangular" sx={{ borderRadius: "11px" }} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
}
SkeletonContent.propTypes = { rowsPerPage: PropTypes.number.isRequired };

function LLMScannersTable(props) {
  const { resultsScore, resultsValid, configs } = props;

  const [currentScanner, setCurrentScanner] = React.useState(null);

  const [viewOpen, setViewOpen] = React.useState(false);
  const viewHandleOpen = () => setViewOpen(true);
  const viewHandleClose = () => setViewOpen(false);

  const handleClickMore = (scanner) => {
    setCurrentScanner(scanner);
    viewHandleOpen();
  };

  return (
    <React.Fragment>
      <Box sx={{ background: "white", padding: "16px 12px" }}>
        {/* <Grid container px={4} pb={6}>
          <Grid item>
            <Typography variant="h2" display="inline">
              LLM Prompt Scanners
            </Typography>
          </Grid>
        </Grid> */}
        <Paper sx={{ maxWidth: "90vw", boxShadow: "none" }}>
          <TableContainer>
            <Table aria-labelledby="tableTitle" size={"medium"} aria-label="enhanced table">
              <EnhancedTableHead />
              {resultsValid === null ? (
                <SkeletonContent rowsPerPage={3} />
              ) : Object.keys(resultsValid).length === 0 ? 
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={9}>
                      <Typography textAlign="center">No scanners</Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              : (
                <TableBody>
                  {Object.keys(resultsValid)?.map((scanner, index) => {
                    return (
                      <TableRow hover tabIndex={-1} key={`${scanner}-${index}`}>
                        <TableCell align="left" sx={{ padding: "8px" }}>
                          {scanner}
                        </TableCell>
                        <TableCell align="center" sx={{ padding: "8px" }}>
                          {resultsValid[scanner] ? (<CheckCircleOutlineIcon sx={{ fill: "green" }} style={{ height: "20px" }} />)
                          :(<HighlightOffIcon sx={{ fill: "red" }} style={{ height: "20px" }} />)
                          }
                        </TableCell>
                        <TableCell align="center" sx={{ padding: "8px" }}>
                          {resultsScore?.[scanner] ?? ''}
                        </TableCell>
                        <TableCell align="center" sx={{ padding: "8px" }}>
                          <IconButton
                            size="large"
                            aria-label="details"
                            id="demo-customized-button"
                            onClick={() => handleClickMore(scanner)}
                          >
                            <MoreVertIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Paper>
      </Box>
      <Modal open={viewOpen} onClose={viewHandleClose}>
        <ModalBox sx={{ width: "40vw" }}>
          <Grid container borderBottom={"solid 1px #E9E9E9"}>
            <Grid item xs={12}>
              <Grid container px={3.5} py={2.5}>
                <Grid item sx={{ margin: "auto" }}>
                  <Typography variant="h1">{`${currentScanner} Configuration`}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container px={3.5} pt={2.5} pb={5} borderBottom={"solid 1px #E9E9E9"}>
            <Grid item xs={12}>
              <ReactJson name="raw" src={configs?.[scannerNameMap?.[currentScanner] ?? ''] ?? {}} displayDataTypes={false} style={{ wordBreak: "break-word" }} />
            </Grid>
          </Grid>
          <Grid container px={7} pb={5}>
            <Grid item xs={12} pt={8} textAlign={"right"}>
              <Button variant="outlined" color="primary" size="modal" startIcon={<CancelIcon />} onClick={viewHandleClose}>
                Close
              </Button>
            </Grid>
          </Grid>
        </ModalBox>
      </Modal>
    </React.Fragment>
  );
}
LLMScannersTable.propTypes = {
  resultsScore: PropTypes.object.isRequired,
  resultsValid: PropTypes.object.isRequired,
  configs: PropTypes.object.isRequired,
};
export default LLMScannersTable;
